import { AxiosInstance } from 'axios'
import { useMutation, useQueryClient } from 'react-query'

import { useSvcCrunchesContext } from '@dc-shared-web/providers'

import { Assignment } from '@dc-shared-web/hooks/api/assignment/types'

type UpdateAssignmentParams = {
  assignment_uuid: string
  checklist_data_uuid: string
  user_uuid: string
  crunch_uuid: string
  section_ref_id?: string
}

const updateAssignment = async (
  apiClient: AxiosInstance,
  {
    assignment_uuid,
    checklist_data_uuid,
    user_uuid,
    crunch_uuid,
    section_ref_id,
  }: UpdateAssignmentParams
): Promise<Assignment> => {
  const { data } = await apiClient.patch<Assignment>(
    `/api/assignments/${assignment_uuid}`,
    {
      checklist_data_uuid,
      user_uuid,
      crunch_uuid,
      section_ref_id,
    }
  )

  return data
}

export const useUpdateAssignment = () => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()

  return useMutation(
    (mutationParams: UpdateAssignmentParams) =>
      updateAssignment(apiClient, mutationParams),
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries([
          'assignments',
          variables.checklist_data_uuid,
          variables.crunch_uuid,
        ])
      },
    }
  )
}
